import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div className='p-4'>
            <h1>Политика конфиденциальности</h1>
            <p>Настоящая Политика конфиденциальности описывает, как сайт <strong>HajjTravel.kz</strong>, предоставляемый ТОО &laquo; ХаджТревел&raquo;, собирает, использует и защищает персональные данные пользователей.</p>
            <h3>1. Сбор информации</h3>
            <p>Мы собираем следующую информацию при оформлении заказов на туры:</p>
            <ul>
                <li>
                    <p>ФИО</p>
                </li>
                <li>
                    <p>Контактный номер телефона</p>
                </li>
                <li>
                    <p>Электронную почту</p>
                </li>
                <li>
                    <p>Паспортные данные (для бронирования и оформления виз)</p>
                </li>
                <li>
                    <p>Платёжную информацию (не сохраняется на наших серверах)</p>
                </li>
            </ul>
            <h3>2. Использование информации</h3>
            <p>Собранные данные используются для:</p>
            <ul>
                <li>
                    <p>Оформления и подтверждения заказов</p>
                </li>
                <li>
                    <p>Связи с клиентом</p>
                </li>
                <li>
                    <p>Подготовки документов для поездки</p>
                </li>
                <li>
                    <p>Внутренней аналитики и улучшения сервиса</p>
                </li>
            </ul>
            <h3>3. Конфиденциальность и безопасность</h3>
            <p>Мы соблюдаем требования законодательства РК и принимаем меры по защите персональных данных от несанкционированного доступа.</p>
            <h3>4. Передача третьим лицам</h3>
            <p>Мы не передаём ваши данные третьим лицам, за исключением:</p>
            <ul>
                <li>
                    <p>Туроператоров и авиакомпаний (только необходимые данные)</p>
                </li>
                <li>
                    <p>Государственных органов по запросу в рамках закона</p>
                </li>
            </ul>
            <h3>5. Контакт</h3>
            <p>Если у вас есть вопросы, свяжитесь с нами:📧 Email: <a rel="noopener">info@hajjtravel.kz</a><br />📞 Телефон: +7 (705)408 31 30</p>
        </div>
    )
}

export default PrivacyPolicy;